export const FETCH_OBSOLESCENCE_PARAMETERS_REQUEST = '@@toyota/FETCH_OBSOLESCENCE_PARAMETERS_REQUEST';
export const FETCH_OBSOLESCENCE_PARAMETERS_SUCCCESS = '@@toyota/FETCH_OBSOLESCENCE_PARAMETERS_SUCCCESS';
export const FETCH_OBSOLESCENCE_PARAMETERS_FAILED = '@@toyota/FETCH_OBSOLESCENCE_PARAMETERS_FAILED';

export const SAVE_OBS_PARAMS_REQUEST = '@@toyota/SAVE_OBS_PARAMS_REQUEST';
export const SAVE_OBS_PARAMS_SUCCESS = '@@toyota/SAVE_OBS_PARAMS_SUCCESS';
export const SAVE_OBS_PARAMS_FAILED = '@@toyota/SAVE_OBS_PARAMS_FAILED';
